var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningUnbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.93 40.456"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.053 31.079L28.282 2.998a6.215 6.215 0 00-10.634 0L.876 31.079a6.218 6.218 0 005.317 9.377h33.544a6.042 6.042 0 005.365-3.142 6.13 6.13 0 00-.048-6.235zm-22.089 2.8a2.61 2.61 0 112.61-2.61 2.6 2.6 0 01-2.609 2.614zm2.8-19.866l-.911 10.785a1.885 1.885 0 01-2.03 1.692 1.859 1.859 0 01-1.692-1.692l-.918-10.779a2.814 2.814 0 015.607-.483 1.641 1.641 0 00-.048.483z",
    fill: "#f60"
  })));
}

export default __webpack_public_path__ + "ab8beafaa5ab70db680886fb310b610e.svg";
export { SvgWarningUnbound as ReactComponent };